import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

function accordeon () {

  $(document).on('click', '.js-accordeon-toggler', e => {
    e.preventDefault()

    const target = e.currentTarget
    const accordeon = target.closest('.js-accordeon')
    const item = target.closest('.js-accordeon-item')
    const content = item.querySelector('.js-accordeon-content')

    const items = accordeon.querySelectorAll('.js-accordeon-item')
    const contents = accordeon.querySelectorAll('.js-accordeon-content')

    if (!accordeon.classList.contains('active')) {
      items.forEach( el => { 
        const content = el.querySelector('.js-accordeon-content')
        el.classList.contains('active') ? content.style.display = 'block' : content.style.display = 'none'
      })
    }

    accordeon.classList.add('active')

    if (item.classList.contains('active')) {
      item.classList.remove('active')
      $(content).slideUp(300).promise().done( function () {
        $(this).css({ 'display': 'none' })
        ScrollTrigger.refresh()
      } )
    } else {
      items.forEach(el => el.classList.remove('active'))

      contents.forEach(el => {
        $(el).slideUp(300).promise().done(function () {
          $(this).css({ 'display': 'none' })
          ScrollTrigger.refresh()
        })
      })

      item.classList.add('active')

      $(content).slideDown(300).promise().done(function () {
        $(this).css({ 'display': 'block' })
        ScrollTrigger.refresh()
      })
    }

  }) 

}

export { accordeon }

